import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import { EvtStatsCard } from "components/stats/display-card";
import { Badge } from "ui/components/badge";
import { formatDateForDisplay } from "utils/utils";
import { STATUSES } from "@/components/status/constant";
import { useFetch } from "@/hooks/useFetch";
import { fetchInterviewMeta } from "./api";

export default function InterviewDetails() {
    const { interviewId } = useParams();

    const { data: interview, isLoading, isError } = useFetch({
        queryKey: [interviewId],
        queryFn: () => fetchInterviewMeta({ interviewId }),
    });

    if (isLoading) return <div className="p-8">Loading...</div>;

    if (isError) return (
        <div className="p-8 text-red-500">Error loading interview details.</div>
    );

    if (!interview) return <div className="p-8">No interview found.</div>;

    const status = STATUSES[interview?.status];
    const cleared = interview?.is_cleared

    return (
        <div className="flex-1">
            <EvtHeader title={interview?.title} />

            <section>
                <div className="grid grid-cols-3 px-4 gap-4 md:px-6 mt-2.5 min-h-24">
                    {/* Status */}
                    <EvtStatsCard
                        label="Status"
                        value={<div className="flex"><Badge className={status?.className}>{status?.label}</Badge></div>}
                    />
                    {/* Schedule Date */}
                    <EvtStatsCard
                        label="Schedule Date"
                        value={<p className="text-base">
                            {formatDateForDisplay(interview?.date_scheduled)}
                        </p>}
                    />
                    {/* Cleared */}
                    <EvtStatsCard
                        label="Cleared"
                        value={<p className="text-base">{cleared ? "Yes" : "No"}</p>}
                    />
                </div>
            </section>

            <section>
                <div className="flex flex-col px-4 gap-4 md:px-6 mt-2.5">
                    {interview?.recording_url && <div>
                        <div className="font-medium mb-1">Recording</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            <a href={interview?.recording_url} target="_blank" rel="noopener noreferrer">{interview?.recording_url}</a>
                        </div>
                    </div>}
                    {interview?.internal_feedback && <div>
                        <div className="font-medium mb-1">Internal Feedback</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            {interview?.internal_feedback}
                        </div>
                    </div>}
                    {interview?.transcript && <div>
                        <div className="font-medium mb-1">Transcript</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            {interview?.transcript}
                        </div>
                    </div>}
                    {interview?.client_feedback && <div>
                        <div className="font-medium mb-1">Client Feedback</div>
                        <div className="font-normal text-sm leading-relaxed text-gray-700 bg-gray-50/50 p-4 rounded-lg border border-gray-200/60 whitespace-pre-wrap">
                            {interview?.client_feedback}
                        </div>
                    </div>}
                </div>
            </section>
        </div>
    );
}
